{
  "accountInformationText": "قم بتحديث تفاصيل حسابك الشخصي أدناه.",
  "accountSettings": "إعدادات الحساب",
  "accountStatus": "حالة الحساب",
  "accountStatusText": "حسابك في حالة جيدة حاليًا.",
  "active": "نشط",
  "administrator": "مسؤول",
  "backupCodeFailed": "فشل التحقق من الرمز الاحتياطي.",
  "backupCodes": "رموز احتياطية",
  "backupCodesWarning": "سيتم عرض هذه الرموز مرة واحدة فقط. احتفظ بها في مكان آمن. يمكن استخدام كل رمز مرة واحدة فقط.",
  "changePassword": "تغيير كلمة المرور",
  "confirmPassword": "تأكيد كلمة المرور",
  "copyBackupCodes": "نسخ الرموز الاحتياطية",
  "currentPassword": "كلمة المرور الحالية",
  "darkMode": "الوضع الداكن",
  "depositWithdrawalAlerts": "تنبيهات الإيداع والسحب",
  "disable2FA": "تعطيل التحقق بخطوتين",
  "disable2fa": "تعطيل Google Authenticator",
  "downloadBackupCodes": "تنزيل الرموز الاحتياطية",
  "emailNotifications": "إشعارات البريد الإلكتروني",
  "enterAuthenticatorCode": "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة",
  "enterAuthenticatorCodeFirst": "يرجى إدخال رمز المصادقة أولاً.",
  "enterSixDigitCode": "أدخل الرمز المكون من 6 أرقام",
  "goToKycVerification": "الانتقال إلى التحقق من الهوية",
  "googleAuthenticator2fa": "Google Authenticator (التحقق بخطوتين)",
  "googleAuthenticator2faText": "أضف طبقة إضافية من الأمان لحسابك باستخدام Google Authenticator.",
  "googleAuthenticatorDisabled": "تم تعطيل Google Authenticator.",
  "googleAuthenticatorEnabled": "تم تفعيل Google Authenticator.",
  "inactive": "غير نشط",
  "invalidCode": "رمز غير صحيح. يرجى المحاولة مرة أخرى.",
  "invalidVerificationCode": "رمز التحقق غير صحيح.",
  "kycStatusText": "أكمل التحقق من الهوية لفتح جميع ميزات الحساب.",
  "language": "اللغة",
  "languagePreferencesText": "اختر اللغة المستخدمة في جميع أنحاء حسابك.",
  "languageSettings": "إعدادات اللغة",
  "lightMode": "الوضع الفاتح",
  "loading": "جاري التحميل...",
  "loginAlerts": "تنبيهات تسجيل الدخول",
  "manualSetupKey": "مفتاح الإعداد اليدوي",
  "newBackupCodesGenerated": "تم إنشاء رموز احتياطية جديدة. احفظها في مكان آمن.",
  "newPassword": "كلمة المرور الجديدة",
  "notificationPreferences": "تفضيلات الإشعارات",
  "notificationPreferencesText": "اختر التنبيهات التي ترغب في تلقيها.",
  "notificationSettings": "إعدادات الإشعارات",
  "owner": "المالك",
  "ownerControlCenter": "مركز تحكم المالك",
  "ownerDisableBlocked": "لا يمكن لحساب المالك تعطيل Google Authenticator.",
  "p2pAlerts": "تنبيهات P2P",
  "p2pOrderAlerts": "تنبيهات طلبات P2P",
  "pushNotifications": "الإشعارات الفورية",
  "regenerateBackupCodes": "إنشاء رموز احتياطية جديدة",
  "require2FASetup": "يلزم إعداد Google Authenticator قبل المتابعة.",
  "role": "الدور",
  "saveBackupCodes": "حفظ الرموز الاحتياطية",
  "saveChanges": "حفظ التغييرات",
  "saving": "جارٍ الحفظ...",
  "scanQrCode": "امسح رمز الاستجابة السريعة هذا",
  "scanQrCodeAuthenticator": "امسح رمز الاستجابة السريعة هذا باستخدام تطبيق المصادقة",
  "securityAlerts": "تنبيهات الأمان",
  "securityRules": "قواعد الأمان",
  "securitySettings": "إعدادات الأمان",
  "selectLanguage": "اختر اللغة",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.",
  "settingRuleBotProtection": "الحماية التلقائية من نشاط البوتات مفعّلة على هذا الحساب.",
  "settingRuleDepositReview": "تتم مراجعة الإيداعات الكبيرة قبل إضافتها إلى رصيدك.",
  "settingRuleKyc": "التحقق من الهوية مطلوب قبل الموافقة على عمليات السحب.",
  "settingRuleManualReview": "قد يؤدي النشاط المشبوه إلى مراجعة أمنية يدوية.",
  "settingRuleWalletMatch": "يجب أن تتطابق عمليات السحب مع عنوان محفظة موثّق.",
  "settingsSubtitle": "إدارة حسابك ولغتك والتحقق والأمان.",
  "settingsTitle": "الإعدادات والأمان",
  "settingsUpdateFailed": "فشل تحديث الإعدادات.",
  "settingsUpdated": "تم تحديث الإعدادات بنجاح.",
  "setup2FA": "إعداد Google Authenticator",
  "setupGoogleAuthenticator": "إعداد Google Authenticator",
  "systemDefault": "افتراضي النظام",
  "theme": "المظهر",
  "twoFaSetupFailed": "فشل إعداد التحقق بخطوتين.",
  "twoFactorAuthentication": "Google Authenticator (التحقق بخطوتين)",
  "twoFactorDescription": "احمِ حسابك باستخدام Google Authenticator.",
  "twoFactorDisabled": "تم تعطيل التحقق بخطوتين",
  "twoFactorDisabledSuccess": "تم تعطيل Google Authenticator بنجاح.",
  "twoFactorEnabled": "تم تفعيل التحقق بخطوتين",
  "twoFactorSecurity": "أمان التحقق بخطوتين",
  "twoFactorSecurityText": "فعّل التحقق بخطوتين لحماية أقوى لحسابك.",
  "twoFactorSetupFailed": "فشل إعداد التحقق بخطوتين.",
  "twoFactorVerified": "تم تفعيل Google Authenticator بنجاح.",
  "user": "مستخدم",
  "verificationCode": "رمز التحقق",
  "verify2FA": "التحقق والتفعيل",
  "verifyAndEnable": "تحقق وفعّل"
}